import React from 'react';
import get from 'lodash/get';

export default props => {
  return (
    <div className="form-group">
      <div className="form-group-details">
          <h4>{!props.token && (['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(get(props, 'consentMethodType'))) ? 'Confirmation - E-mail Consent has been sent to patient for signature!' : 'Confirmation - Consent has been provided!' }</h4>
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
          <h5>Consent Type: <b>{props.consentPersonType}</b></h5>
          <h5>Consent Method: <b>{props.consentMethodType}</b></h5>
          {['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && <h5>Consent Email Status: <b>{props.consentExistsEmailStatus.replace(/_/g, ' ')}</b></h5>}
          {props.consentExistsLink && (
            Array.isArray(props.consentExistsLink) ?
              (props.consentExistsLink.map(({ link, name }) => (
                <h5>Document Link: <b><a href={link} target="_blank">{name}</a></b></h5>
              )))
              :
              (<h5>Document Link: <b><a href={props.consentExistsLink.link} target="_blank">{props.consentExistsLink.name}</a></b></h5>)
          )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLethbridge/Step4.js